<a
  *ngIf="url.length; else image"
  [href]="'/' + url[0].uri"
  [routerLink]="'/' + url[0].uri"
  [target]="url[0].options.attributes.target === 1 ? '_blank' : ''"
  [rel]="url[0].options.attributes.rel"
  [class]="url[0].options.attributes.class"
  [attr.analytics-alternate-text]="analyticsLinkText"
>
  <ng-container *ngTemplateOutlet="image"></ng-container>
</a>

<ng-template #image>
  <div class="inline-style" [innerHtml]="mediaQueryStyles | safeHtml"></div>
  <picture>
    <source
      [media]="mq.mobile"
      [srcset]="mobileWebpMedia.src | encodePath"
      [type]="getMediaType(mobileWebpMedia.src)"
    />
    <source
      [media]="mq.midsize"
      [srcset]="midWebpMedia.src | encodePath"
      [type]="getMediaType(midWebpMedia.src)"
    />
    <source
      [media]="mq.desktop"
      [srcset]="desktopWebpMedia.src | encodePath"
      [type]="getMediaType(desktopWebpMedia.src)"
    />
    <source
      [srcset]="fallbackWebpMedia.src | encodePath"
      [type]="getMediaType(fallbackWebpMedia.src)"
    />
    <img
      [id]="imageId"
      [alt]="mobileWebpMedia.alt || desktopWebpMedia.alt"
      [attr.loading]="loading.value"
      [src]="emptyCmsImage.src"
      [ngClass]="classNames"
    />
  </picture>
</ng-template>
